import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function MapVersions() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("versions");
  }, [setStyleEditorView]);

  return null;
}
